import { render, staticRenderFns } from "./document-view.vue?vue&type=template&id=d864b734&scoped=true"
import script from "./document-view.vue?vue&type=script&lang=js"
export * from "./document-view.vue?vue&type=script&lang=js"
import style0 from "./document-view.vue?vue&type=style&index=0&id=d864b734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d864b734",
  null
  
)

export default component.exports